import { call } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { AxiosRequestConfig } from 'axios'
import type { PayloadAction } from '@reduxjs/toolkit'

const { download } = RequestMethods()

export interface ISagaWorker_GetTrailersLeasingCsv {
  leasingCompanyId: number
}

export default function* SagaWorker_GetTrailersLeasingCsv(action: PayloadAction<ISagaWorker_GetTrailersLeasingCsv>) {
  const leasingCompanyId = action.payload.leasingCompanyId

  const config = {
    responseType: 'blob',
  } as AxiosRequestConfig

  try {
    //------------------------- Getting report ---------------------------//
    yield call(async () => download(`/trailers/report/leasing/${leasingCompanyId}/csv`, undefined, config))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  }
}
